import * as React from 'react';
import styled from 'styled-components';
import { body2 } from '@westwing/ui-kit/typography';
import { forTablet } from '@westwing/ui-kit/breakPoints';
import TickIcon from './Icons/TickIcon';
import { SerializedPriceTier } from '@ids/types/now-api';

export const StyledBenefits = styled.ul``;
const StyledBenefit = styled.li`
    ${body2}
    color: ${({ theme }) => theme.colors.charcoal100};
    display: flex;
    align-items: center;
    margin-top: 26px;

    &:last-of-type {
        margin-bottom: 12px;
    }

    ${forTablet`
        &:first-of-type {
            margin-top: 36px;
        }
    `}
`;

interface BenefitsProps {
    benefits: SerializedPriceTier['benefits'];
}

const Benefits = ({ benefits }: BenefitsProps) => (
    <StyledBenefits>
        {benefits.map(benefit => (
            <StyledBenefit key={benefit}>
                <span>
                    <TickIcon style={{ marginRight: '10px' }} />
                </span>
                <span>{benefit}</span>
            </StyledBenefit>
        ))}
    </StyledBenefits>
);

export default Benefits;
